import { ajaxPostJson, setParams } from './ajax';
//获取团队角色与人数
export const teamNumber = (params) => {
  return ajaxPostJson(`/companyUser/countCompanyUserRole`, params, 'BaseApi');
};
//获取角色列表
export const queryManagementPage = (params) => {
  params.filter = setParams(params.filter);
  return ajaxPostJson(`/companyUser/queryPage`, params, 'BaseApi');
};
//删除角色
export const deleteUser = (params) => {
  return ajaxPostJson(`/companyUser/delete`, params, 'BaseApi');
};
//获取登陆用户下有权限的角色列表
export const getRoleList = (params) => {
  return ajaxPostJson(`/role/querySelfRoleList`, params, 'BaseApi');
};
//根据角色id获取权限
export const getRoleId = (params) => {
  // 菜单版本控制
  params.version = MENU_VERSION;
  return ajaxPostJson(`/role/queryRoleResource`, params, 'BaseApi');
};
//添加成员
export const addMembers = (params) => {
  return ajaxPostJson(`/companyUser/addProjectManager`, params, 'BaseApi');
};
//邀请成员
export const inviteMembers = (params) => {
  return ajaxPostJson(`/companyUser/inviteUserSendMessage`, params, 'BaseApi');
};
//邀请成员 // 手机号
export const inviteMembersByPhone = (params) => {
  return ajaxPostJson(`/companyUser/inviteUserSendMessageByPhone`, params, 'BaseApi');
};
//编辑
export const editUsers = (params) => {
  return ajaxPostJson(`/companyUser/updateProjectManager`, params, 'BaseApi');
};
//团队管理取消邀请
export const disinvitation = (params) => {
  return ajaxPostJson(`/companyUser/cancelInvite`, params, 'BaseApi');
};
export const disinvitationByPhone = (params) => {
  return ajaxPostJson(`/companyUser/cancelInviteByPhone`, params, 'BaseApi');
};
//接受和拒绝邀请
export const userAcceptRefuse = (params) => {
  return ajaxPostJson(`/companyUser/updateInviteByUser`, params, 'BaseApi');
};
//获取所有资源
export const getAllResource = (params = {}) => {
  // 菜单版本控制
  params.version = MENU_VERSION;
  return ajaxPostJson(`/resource/queryResAll`, params, 'BaseApi');
};
// 获取组织树
export const queryUserDepartTree = (params) => {
  return ajaxPostJson(`/companyUser/queryUserDepartTree`, params, 'BaseApi');
};
// 点击组织树节点查询成员
export const queryPageTeam = (params) => {
  params.filter = setParams(params.filter);
  //分页
  // return ajaxPostJson(`/companyUser/queryPageTeam`, params, 'BaseApi');
  //不分页
  return ajaxPostJson(`/companyUser/queryTeamList`, params, 'BaseApi');
};
// 批量添加用户
export const inviteUserBatch = (params) => {
  return ajaxPostJson(`/companyUser/inviteUserBatch`, params, 'BaseApi');
};
//查看任务详情
export const getTaskDetail = (params) => {
  return ajaxPostJson(`/fileTask/getTaskDetail`, params);
}
// layout读取消息
export const readUserMessage = (params) => {
  return ajaxPostJson(`/user/readUserMessage`, params);
}
// 获取邀请二维码
export const createTeamQrCode = (params) => {
  return ajaxPostJson(`/companyUser/createTeamQrCode`, params);
}
//组织架构人员信息分页--用户班级管理
export const getTeamUserPage = (params) => {
  //分页
  return ajaxPostJson(`/companyUser/queryTeamUserList`, params);
  //不分页
  // return ajaxPostJson(`/companyUser/queryTeamUserPage`, params);
}
//分配作业给班级(含创建班级)
export const assignHomeworkAjax = (params) => {
  return ajaxPostJson(`/fileTask/assignHomework`, params);
}